import { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const translations = useMemo(() => {
    return {
      titleCenterServicesToRead: formatMessage(
        messages.titleCenterServicesToRead,
      ),
      titleAiReports: formatMessage(messages.titleAiReports),
      titleAdmin: formatMessage(messages.titleAdmin),
    };
  }, [formatMessage]);

  return translations;
};

export default useTranslations;
